import absencesTableSaga from "./redux/absencesTable/absencesTable.saga"
import authenticationSaga from "./redux/authentication/authentication.saga"
import authorizationSaga from "./redux/authorization/authorization.saga"
import balanceHoursSaga from "./redux/balanceHours/balanceHours.saga"
import balanceHoursCorrectionsSaga from "./redux/balanceHoursCorrections/balanceHoursCorrections.saga"
import currentUserSaga from "./redux/currentUser/currentUser.saga"
import codesSaga from "./redux/codes/codes.saga"
import codesByCategorySaga from "./redux/codesByCategory/codesByCategory.saga"
import functionsSaga from "./redux/functions/functions.saga"
import hrGeneralLeavesSaga from "./redux/hrGeneralLeaves/hrGeneralLeaves.saga"
import hrUnavailabilitiesSaga from "./redux/hrUnavailabilities/hrUnavailabilities.saga"
import personalPlanning from "./redux/personalPlanning/personalPlanning.saga"
import personalPlanningChannel from "./redux/personalPlanningChannel/personalPlanningChannel.saga"
import planningAvailabilities from "./redux/planningAvailabilities/planningAvailabilities.saga"
import planningWeekAvailabilities from "./redux/planningWeekAvailabilities/planningWeekAvailabilities.saga"
import planningConflictsSaga from "./redux/planningConflicts/planningConflicts.saga"
import planningImportSaga from "./redux/planningImport/planningImport.saga"
import planningTimeslotsSaga from "./redux/planningTimeslots/planningTimeslots.saga"
import practiceSaga from "./redux/practice/practice.saga"
import practicesSaga from "./redux/practices/practices.saga"
import preferedHoursSaga from "./redux/preferedHours/preferedHours.saga"
import requestsSaga from "./redux/requests/requests.saga"
import rolesSaga from "./redux/roles/roles.saga"
import shiftsSaga from "./redux/shifts/shifts.saga"
import templatesSaga from "./redux/templates/templates.saga"
import templateAvailabilitiesSaga from "./redux/templateAvailabilities/templateAvailabilities.saga"
import timeslotsSaga from "./redux/timeslots/timeslots.saga"
import urlSaga from "./redux/url/url.saga"
import userAbsencesSaga from "./redux/userAbsences/userAbsences.saga"
import userLeavesSaga from "./redux/userLeaves/userLeaves.saga"
import usersSaga from "./redux/users/users.saga"
import weeksSaga from "./redux/weeks/weeks.saga"
import workstationsSaga from "./redux/workstations/workstations.saga"
import workstationAvailabilitiesSaga from "./redux/workstationAvailabilities/workstationAvailabilities.saga"
import templateWorkstationAvailabilitiesSaga from "./redux/templateWorkstationAvailabilities/templateWorkstationAvailabilities.saga"
import moduleContextSaga from "./redux/moduleContext/moduleContext.saga"
import templateWeekAvailabilitiesSaga from "./redux/templateWeekAvailabilities/templateWeekAvailabilities.saga"
import planningTimeslotsChannel from "./redux/planningTimeslotsChannel/planningTimeslotsChannel.saga"
import templateTimeslotsChannel from "./redux/templateTimeslotsChannel/templateTimeslotsChannel.saga"
import ContractsSaga from "./redux/contracts/contracts.saga"
import hrLeaveEntitlementsSaga from "./redux/hrLeaveEntitlements/HrLeaveEntitlements.saga"
import hrUnavailabilitiesOverviewSaga from "./redux/hrUnavailabilitiesOverview/hrUnavailabilitiesOverview.saga"

export default [
  moduleContextSaga,
  absencesTableSaga,
  authenticationSaga,
  authorizationSaga,
  balanceHoursSaga,
  balanceHoursCorrectionsSaga,
  codesByCategorySaga,
  codesSaga,
  ContractsSaga,
  currentUserSaga,
  functionsSaga,
  hrGeneralLeavesSaga,
  personalPlanning,
  personalPlanningChannel,
  planningAvailabilities,
  planningWeekAvailabilities,
  planningConflictsSaga,
  planningImportSaga,
  planningTimeslotsSaga,
  practiceSaga,
  practicesSaga,
  preferedHoursSaga,
  requestsSaga,
  rolesSaga,
  shiftsSaga,
  templatesSaga,
  timeslotsSaga,
  urlSaga,
  userAbsencesSaga,
  userLeavesSaga,
  usersSaga,
  weeksSaga,
  workstationsSaga,
  workstationAvailabilitiesSaga,
  templateAvailabilitiesSaga,
  templateWeekAvailabilitiesSaga,
  templateWorkstationAvailabilitiesSaga,
  planningTimeslotsChannel,
  templateTimeslotsChannel,
  hrUnavailabilitiesSaga,
  hrLeaveEntitlementsSaga,
  hrUnavailabilitiesOverviewSaga,
]
